import { Formats } from 'features/maps/types'
import { LayerLoader, LayerLoaderProps } from './layerLoader'

export class TilesetLayerLoader extends LayerLoader {
  constructor(props: LayerLoaderProps) {
    super(props)
    const { format } = props
    // Compatibility with old maps
    this.format = format || Formats.TILEJSON
  }
}
